import React, { useEffect, useState } from "react";
import TelephoneNumbers from "../../components/TelephoneNumbers";
import { UpdateAccPinCID } from "../../apiclients/streamsapi_bridge";

function AssignedNumberConference({
  sourceNumber,
  setSuccessMessage,
  setIsloading,
  setError,
  conferenceNumber,
}) {
  const [assignedNumbers, setassignedNumbers] = useState([]);
  const [dbPhoneNumbers, setDbPhoneNumbers] = useState([]);
  const [updatePHNum, setUpdatePHNum] = useState(false);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);

  useEffect(() => {
    setassignedNumbers(conferenceNumber ?? []);
    setDbPhoneNumbers(conferenceNumber ?? []);
  }, [conferenceNumber]);

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("ass_cacb_phnum");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("unass_cacb_phnum");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 64,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      global_settings: {
        global_acc_settings: {
          [fieldName]: updatePHNum,
        },
      },
    };

    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await UpdateAccPinCID(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "ass_cacb_phnum") {
        setassignedNumbers((prev) => [...prev, ...updatePHNum]);
        setDbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} added successfully.`
        );
      } else {
        const updateAddPHNum = assignedNumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setassignedNumbers(updateAddPHNum);
        setDbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        );
      }
    } else {
      if (fieldName === "unass_cacb_phnum") {
        const modifynum = assignedNumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setassignedNumbers([...modifynum, ...updatePHNum]);
        setDbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
      if (saverepeMsg.message?.errors) {
        if (
          saverepeMsg.message?.errors[0].errors &&
          saverepeMsg.message?.errors[0].errors.length > 0
        ) {
          saverepeMsg.message?.errors[0].errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
    }
    setIsloading(false);
  }

  return (
    <>
      <TelephoneNumbers
        savedPhoneNumbers={assignedNumbers}
        setSavedPhoneNumbers={setassignedNumbers}
        setSuccessMessage={setSuccessMessage}
        uniqueid={null}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
      />
    </>
  );
}

export default AssignedNumberConference;
